// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-content-container {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/AppContent/style.scss"],"names":[],"mappings":"AAAA;EAEI,UAAA;AAAJ","sourcesContent":[".app-content-container {\n    // padding: 1.8rem 1.8rem .5rem; \n    padding: 0;\n\n    // &--reset-padding {\n    //     padding: 0 0 0 10px;\n    // }\n    // &--reset-padding-mobile {\n    //     padding: 0 0 0 0;\n    //     background-color: var(--m-white);\n    // }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
